export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите имя ', trigger: 'blur' },
    ],
    corps_id: [
        { required: true, message: 'Пожалуйста, введите корпус ', trigger: 'blur' },
    ],
};
